module.exports = __webpack_public_path__ + "1793882494189/images/socicon.a35b657.svg";